import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type initialStateType = {
    is_drawer_open: boolean;
};

const initialState: initialStateType = {
    is_drawer_open: true,
};

const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        toggleSideMenu: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_drawer_open: action.payload,
            };
        },
    }
});

export const { toggleSideMenu } = globalSlice.actions;
export default globalSlice.reducer;